(function() {
  var _log = console.log;
  // eslint-disable-next-line no-unused-vars
  console.log = function(message) {
    if (localStorage.getItem("debugMode") == "true") {
      _log.apply(console, arguments);
    }
  };

  if (!String.format) {
    String.format = function(format) {
      var args = Array.prototype.slice.call(arguments, 1);
      return format.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != "undefined" ? args[number] : match;
      });
    };
  }
})();
